import React, { useState } from 'react'
import { useHistory } from "react-router-dom";
import { motion } from 'framer-motion'
import axios from 'axios'
import { useSelector } from 'react-redux'
import swal from 'sweetalert';


import { Submit } from '../Button'


import commoncss from "../../myfin_v2/css/common.module.css";
import buttoncss from "../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../myfin_v2/elements/Modal";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { Button } from "../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";




const screen = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    zIndex: '999',
    backgroundColor: '#00000036',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

}
const container = {
    // width:'30%',
    minHeight: '20vh',
    borderRadius: '10px',
    // maxHeight:'90vh',
    padding: '2rem 4rem',

    zIndex: '999',
    backgroundColor: '#f5f7fa'
}

const head = {
    display: 'flex'
}


const header = {
    fontSize: '2rem',
    fontWeight: '600'
}
const para = {
    fontSize: '14px',
    fontWeight: '400',
    marginTop: '0px',
    color: '#696F79'
}

const input = {
    width: '100%',
    height: '3rem',
    borderRadius: '6px',
    outline: 'none',
    border: '1px solid #D0D0D0',
    padding: '10px',
    fontSize: '20px',
    color: 'var(--clr-font-dark)'

}
const footSelect = {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginTop: '1.2rem'

}

const presetHeader = {
    fontSize: '14px',
    color: 'var(--clr-font-mid)',
    margin: '0 0 5px 0px'
}

const PopulateFs = (props) => {
    let history = useHistory()

    const TB_ID = useSelector(initialState => initialState.reducer.tb_id)
    const auth = localStorage.getItem('auth_token')
    let headers = {
        'x-auth-token': auth,

    }
    const project_id = localStorage.getItem('project_id');

    const [preset, setPreset] = useState('')

    function handleClose(e) {
        // if (e.target.classList.contains('screenDiv')) {
            props.setPopulateFs(false)
        // }
    }

    function handleCreate() {

        if (preset === '') {
            swal("", "Preset name cant be empty", "warning");
        }
        else {
            const fd = new FormData()
            fd.append('preset_name', preset);

            axios.post(`/api/v1/presets/save-presets/${project_id}/${TB_ID}`, fd, { headers })
                .then(response => {

                    swal("Preset has been Created!", {
                        icon: "success",
                    });
                    history.push('/preview')
                })
                .catch(error => {
                    console.log(error.response, 'error')
                    // swal("", {error['response']}, "error");
                }
                )
        }
    }

    return (
        <Modal
              title="Create Preset"
              bodycss={commoncss.unsetPadding}
              headerActions={
                <CloseIcon
                  onClick={handleClose}
                  className="clickable"
                />
              }
              onClose={() => console.log("Modal Closed")}
              footerActions={
                <>
                  <Button
                    btnColor={buttoncss.secondary}
                    onClick={() => { history.push('/preview') }}
                    label="Skip"
                  />
                  <Button
                    btnColor={buttoncss.primary}
                    label={"Create Preset"}
                    onClick={() => {handleCreate()}}
                  />
                </>
              }
            >
              <div className={commoncss.pd1530} style={{ paddingTop: "30px", paddingBottom: "40px"}}>
                <InputGroup
                  label="Name of the Preset"
                  inputs={[
                    <>
                      <input
                        type="text"
                        placeholder="Enter Preset Name"
                        value={preset} onChange={(e)=>{setPreset(e.target.value)}}
                      />
                    </>,
                  ]}
                />
              </div>
            </Modal>
    )
}

export default PopulateFs
